export default __webpack_public_path__ + "static/media/research_yellow.1f31e353.svg";